import { render, staticRenderFns } from "./BalanceDateRangeFilter.vue?vue&type=template&id=1636978d&scoped=true"
import script from "./BalanceDateRangeFilter.vue?vue&type=script&lang=js"
export * from "./BalanceDateRangeFilter.vue?vue&type=script&lang=js"
import style0 from "./BalanceDateRangeFilter.vue?vue&type=style&index=0&id=1636978d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636978d",
  null
  
)

export default component.exports